module.exports = __webpack_public_path__ + "media/newstyle/images/completed-purchase-book-ec88d052bb23d33be03b1a40b3c6a266.png";